<!--
 * @Descripttion: 
 * @FilePath: /mall-wap-vue/src/views/login/forgot/components/NavBar/index.vue
 * @Author: 张兴业
 * @Date: 2020-10-10 15:08:56
 * @LastEditors: 张兴业
 * @LastEditTime: 2020-12-21 15:49:57
-->
<template>
  <div class="login_navbar">
    <div class="login_close_back" @click.stop="back">
      <img src="@/assets/login/nav_back.png" alt="" class="login_close" />
    </div>
  </div>
</template>

<script>
export default {
  methods: {
    back() {
      this.$emit("back");
    }
  }
};
</script>

<style lang="less" scoped>
.login_navbar {
  height: 44px;

  .login_close_back {
    padding: 15px 24px;
    width: 24px;
    height: 100%;
    img {
      // padding-top: 10px;
      width: 24px;
      height: 24px;
      display: block;
    }
  }
}
</style>
